import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'
import type { SubscriptionCheckoutPayload } from './autoTopupTypes'

const getSubscription = (): Promise<AxiosResponse> => {
  return Request.get('/auto_topups/subscription/')
}

const createSubscriptionCheckout = (
  payload: SubscriptionCheckoutPayload
): Promise<AxiosResponse> => {
  return Request.post('/auto_topups/checkout/', payload)
}

export default {
  getSubscription,
  createSubscriptionCheckout,
}
